module.exports = __webpack_public_path__ + "static/media/batman.c171a26f.gif";